import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from "@angular/core";

@Component({
	selector: "bp-tab-label",
	template: "<ng-template><ng-content></ng-content></ng-template>",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpTabLabelComponent {
	@ViewChild(TemplateRef) labelContent: TemplateRef<unknown>;
}
